import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
// components
import { SubmitButton } from '../../../../molecules/inputsBlocks/addGroup';
// style
import '../../style.scss';
import './style.scss';
// configs
import { mapping } from '../../../../../api/mapping/request/addEvent';
// types
import { stateType } from '../../../../../types/types';
// actions
import eventsAction from '../../../../../redux/actions/admin_events';
import { AddEventInput, AddTime, CheckboxSelect, EventsSelect } from '../../../../molecules/inputsBlocks/addEvent';
import CustomDatepicker from '../../../../molecules/customDatepicker';
import { sortCommunityEvents } from '../../../../../tools/consts';
import Uploader from '../../../files';
import { arrayOptions } from '../../../../../tools/helpFunctions';

interface FormData {
  title: string;
  subtitle: string;
  topic: any;
  date: any;
  time: any;
  timeLength: number;
  therapistId: number;
  type: number;
  maxParticipants: number;
  eventPhoto: any;
}

const FormEditEvent: React.FC<any> = ({ setVisible, id }: any) => {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<FormData>();

  const optionsTherapists: any = useSelector((state: stateType) => state.groups.therapists, shallowEqual);
  const optionsTopics: any = useSelector((state: stateType) => state.groups.topics, shallowEqual);
  const file: any = useSelector((state: stateType) => state.app.file);
  const { event }: any = useSelector((state: stateType) => state.events, shallowEqual);
  const dispatch = useDispatch();

  const editEventCallback = () => {
    setVisible(false);
  };

  const onSubmit = (data: FormData) => {
    dispatch(eventsAction.edit(id, mapping.addEventBuild(data), editEventCallback));
  };
  useEffect(() => {
    setValue('title', event?.title);
    setValue('subtitle', event?.subtitle);
    setValue(
      'topic',
      event?.groupTopics.map((e: any) => e.id),
    );
    setValue('date', event?.start);
    setValue('time', event?.start);
    setValue('timeLength', event?.timeLength?.value);
    setValue('therapistId', event?.leader?.id);
    setValue('type', event?.communityEventType?.id);
    setValue('maxParticipants', event?.maxAttendees);
    setValue('eventPhoto', event?.picture?.uuid);
  }, []);

  useEffect(() => {
    file && setValue('eventPhoto', file.uuid);
  }, [file]);
  console.log('event', event);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="form-edit-event validation-form">
        <div className="form-edit-event__selections">
          <AddEventInput
            errors={errors.title ? errors.title.message : undefined}
            register={register}
            name="title"
            label="Title"
            placeholder="Type in Event Title"
            defaultValue={event?.title}
          />
          <AddEventInput
            errors={errors.subtitle ? errors.subtitle.message : undefined}
            register={register}
            name="subtitle"
            label="Subtitle"
            placeholder="Type in Event Subtilte"
            defaultValue={event?.subtitle}
          />
          <CheckboxSelect
            errors={errors.topic ? errors.topic.message : undefined}
            control={control}
            register={register}
            options={optionsTopics}
            name="topic"
            label="Topic"
            placeholder="Select topic tags"
            defaultValue={event?.groupTopics.map((e: any) => e.id)}
          />
          <CustomDatepicker
            errors={errors.date ? errors.date.message : undefined}
            control={control}
            name="date"
            label="Date"
            placeholder="Select date"
            format="MMMM Do, YYYY"
            disabled={false}
            defaultValue={event?.start}
          />
          <div className="form-edit-event__row">
            <div className="form-edit-event__column">
              <AddTime
                errors={errors.time ? errors.time.message : undefined}
                control={control}
                name="time"
                label="Start time"
                placeholder="e.g. 6 PM, 12:30 PM"
                defaultValue={event?.start}
              />
            </div>
            <div className="form-edit-event__column">
              <EventsSelect
                errors={errors.timeLength ? errors.timeLength.message : undefined}
                control={control}
                options={sortCommunityEvents.length}
                name="timeLength"
                label="Time Length"
                placeholder="Select time length of event"
                defaultValue={event?.timeLength?.value}
              />
            </div>
          </div>
          <EventsSelect
            errors={errors.therapistId ? errors.therapistId.message : undefined}
            control={control}
            options={optionsTherapists}
            name="therapistId"
            label="Therapist"
            placeholder="Select the therapist"
            defaultValue={
              event?.leader?.firstname
                ? `${event?.leader?.firstname} `
                : '' + event?.leader?.lastname
                ? event?.leader?.lastname
                : ''
            }
          />
          <div className="form-edit-event__row">
            <div className="form-edit-event__column">
              <EventsSelect
                errors={errors.type ? errors.type.message : undefined}
                control={control}
                options={sortCommunityEvents.type}
                name="type"
                label="Type"
                placeholder="Select time length of event"
                defaultValue={event?.communityEventType.id}
              />
            </div>
            <div className="form-edit-event__column">
              <EventsSelect
                errors={errors.maxParticipants ? errors.maxParticipants.message : undefined}
                control={control}
                options={arrayOptions(50)}
                name="maxParticipants"
                label="Max # of participants"
                placeholder="Select the max # of members"
                defaultValue={event?.maxAttendees}
              />
            </div>
          </div>
          <p className="form-edit-event__photo-label">Upload Event Cover Photo</p>
          <Uploader
            defaultValue={event?.picture?.url ? event?.picture.url : ''}
            type={'community_event_picture'}
            className="form-edit-event__photo-uploader"
          />
        </div>
        <div className="form-edit-event__submit-btn">
          <SubmitButton name="Edit" />
        </div>
      </form>
    </>
  );
};

export default FormEditEvent;
